import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import { format, isAfter, subMinutes } from "date-fns";
import { parseISO } from "date-fns";
import {
  Phone as PhoneIcon,
  PhoneCallback as PhoneCallbackIcon,
  PhoneMissed as PhoneMissedIcon,
  CallEnd as CallEndIcon
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  callContainer: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    margin: "8px 0",
    marginRight: "20px",
    minHeight: "60px",
    position: "relative",
    overflow: "hidden",
    maxWidth: "600px",
    alignSelf: "flex-start"
  },
  callIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    flexShrink: 0
  },
  callInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  callTitle: {
    fontWeight: 600,
    fontSize: "14px",
    marginBottom: "4px"
  },
  callSubtitle: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px"
  },
  callTime: {
    fontSize: "11px",
    color: "#999"
  },
  incomingCallIcon: {
    backgroundColor: "#4caf50",
    color: "white",
    animation: "$ring 2s infinite"
  },
  receivedCallIcon: {
    backgroundColor: "#ff9800",
    color: "white"
  },
  acceptedCallIcon: {
    backgroundColor: "#4caf50",
    color: "white"
  },
  rejectedCallIcon: {
    backgroundColor: "#f44336",
    color: "white"
  },
  "@keyframes ring": {
    "0%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 0 rgba(76, 175, 80, 0.7)"
    },
    "70%": {
      transform: "scale(1.05)",
      boxShadow: "0 0 0 10px rgba(76, 175, 80, 0)"
    },
    "100%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 0 rgba(76, 175, 80, 0)"
    }
  },
  "@keyframes pulse": {
    "0%": {
      opacity: 1
    },
    "50%": {
      opacity: 0.5
    },
    "100%": {
      opacity: 1
    }
  }
}));

const CallPreview = ({ message }) => {
  const classes = useStyles();
  const messageTime = parseISO(message.createdAt);
  const callType = message.mediaType;
  const oneMinuteAgo = subMinutes(new Date(), 1);

  const getCallInfo = () => {
    switch (callType) {
      case "call_received":
        if (isAfter(messageTime, oneMinuteAgo)) {
          return {
            title: "Llamada entrante",
            subtitle: "",
            icon: <PhoneIcon />,
            iconClass: classes.incomingCallIcon,
            containerClass: "",
            titleClass: "",
            status: "",
            statusColor: "default",
            titleColor: "#4caf50"
          };
        } else {
          return {
            title: "Llamada perdida",
            subtitle: "",
            icon: <PhoneMissedIcon />,
            iconClass: classes.rejectedCallIcon,
            containerClass: "",
            titleClass: "",
            status: "",
            statusColor: "default",
            titleColor: "#f44336"
          };
        }
      case "call_accepted":
        return {
          title: "Llamada aceptada",
          subtitle: "",
          icon: <PhoneCallbackIcon />,
          iconClass: classes.acceptedCallIcon,
          containerClass: "",
          titleClass: "",
          status: "",
          statusColor: "default",
          titleColor: "#4caf50"
        };
      case "call_rejected":
        return {
          title: "Llamada rechazada",
          subtitle: "",
          icon: <CallEndIcon />,
          iconClass: classes.rejectedCallIcon,
          containerClass: "",
          titleClass: "",
          status: "",
          statusColor: "default",
          titleColor: "#f44336"
        };
      default:
        return {
          title: "Llamada",
          subtitle: "",
          icon: <PhoneIcon />,
          iconClass: classes.receivedCallIcon,
          containerClass: "",
          titleClass: "",
          status: "",
          statusColor: "default",
          titleColor: "#666"
        };
    }
  };

  const callInfo = getCallInfo();

  return (
    <Box className={`${classes.callContainer} ${callInfo.containerClass}`}>
      <div className={`${classes.callIcon} ${callInfo.iconClass}`}>
        {callInfo.icon}
      </div>
      <div className={classes.callInfo}>
        <Typography
          variant="subtitle1"
          className={`${classes.callTitle} ${callInfo.titleClass}`}
          style={{ color: callInfo.titleColor }}
        >
          {callInfo.title}
        </Typography>
        <Typography variant="caption" className={classes.callTime}>
          {format(messageTime, "h:mm a")}
        </Typography>
      </div>
    </Box>
  );
};

export default CallPreview;

